import type { SdkDocNode } from "./types";
import { SDK_DOC_ENTRIES } from "./content";

function leaf(id: string): SdkDocNode {
  const entry = SDK_DOC_ENTRIES[id];
  return {
    id,
    label: entry?.title ?? id,
    description: entry?.summary,
  };
}

/** Documentation tree for Vybe Studio navigator. */
export const SDK_DOCS_TREE: SdkDocNode = {
  id: "sdk-docs-root",
  label: "Vybe Indicators SDK",
  defaultOpen: true,
  children: [
    {
      id: "intro",
      label: "Getting started",
      defaultOpen: true,
      children: [
        leaf("intro-overview"),
        leaf("intro-vs-dsl"),
        leaf("project-csproj"),
      ],
    },
    {
      id: "lifecycle",
      label: "Lifecycle",
      defaultOpen: true,
      children: [
        leaf("lifecycle-oninit"),
        leaf("lifecycle-oncalculate"),
        leaf("lifecycle-ondeinit"),
        leaf("lifecycle-prevcalculated"),
      ],
    },
    {
      id: "types",
      label: "Types",
      children: [
        leaf("type-indicator"),
        leaf("type-series"),
        leaf("type-color"),
        leaf("type-logger"),
      ],
    },
    {
      id: "attributes",
      label: "Attributes",
      children: [
        leaf("attr-indicator"),
        leaf("attr-input"),
        leaf("attr-plot"),
        leaf("attr-pane"),
        leaf("attr-plot-color-index"),
        leaf("attr-plot-bar-style"),
        leaf("attr-candle-color"),
        leaf("attr-signal"),
        leaf("attr-zone"),
        leaf("attr-price-histogram"),
        leaf("attr-dashboard"),
      ],
    },
    {
      id: "best-practices",
      label: "Best practices",
      children: [leaf("best-incremental"), leaf("best-compile")],
    },
    {
      id: "examples",
      label: "Examples",
      defaultOpen: true,
      children: [leaf("example-minimal-ma")],
    },
  ],
};
